// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1m30b","head":"Table_head__3xH5K","col":"Table_col__E3Vex"};